import React from 'react';
import { ArrowLong } from '../../../../assets/img/svg/icons';
import Events from '../../../Components/event';

import { EventInterface } from '../../../Services/types';
interface RelatedInterface {
    events: EventInterface[]
}
const RelatedSection: React.FC<RelatedInterface> = ({events}: RelatedInterface) => {
    return (
        events.length > 0 &&
        <section className='pt-8 pb-10 relative before:content-[""] before:w-dvw before:h-1/3 before:bg-[#EFF9FA] before:absolute before:left-0 before:top-0 before:-z-10'>
            <div className="max-w-screen-lg mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    <h3 className="text-2xl font-semibold text-balance text-center md:text-left">
                        Confira outros eventos da nossa agenda
                    </h3>

                    <a href="/agenda-de-eventos" title="Ver todos os eventos" className={`group rounded-full text-center gap-3 inline-flex justify-center items-center p-4 uppercase text-xs font-semibold max-w-72 transition-all duration-200 w-full border-2 border-main-pink text-main-pink hover:bg-main-pink hover:text-white`}>
                        Ver todos os eventos
                        <ArrowLong className='fill-main-pink transition-all duration-200 group-hover:fill-white' />
                    </a>
                </div>

                <div className="mt-8 grid md:grid-cols-2 gap-8">
                    {events.splice(0, 2).map((event) => (
                        <Events key={event.id} slug={event.slug} local={event.local} title={event.titulo} type={event.tipo} date={event.data} thumbnail={event.thumbnail} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default RelatedSection;